'use client';

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

if (!i18n.isInitialized) {
  const supported = ['en', 'zh', 'ar'];
  const browserLang =
    typeof navigator !== 'undefined'
      ? navigator.languages && navigator.languages.length
        ? navigator.languages[0]
        : navigator.language || 'en'
      : 'en';
  const normalized = browserLang.toLowerCase().split('-')[0];
  const initialLng = supported.includes(normalized) ? normalized : 'en';

  i18n
    .use(HttpBackend)
    .use(initReactI18next)
    .init({
      lng: initialLng,
      fallbackLng: 'en',
      supportedLngs: supported,
      ns: ['common'],
      defaultNS: 'common',
      backend: {
        loadPath: (lngs: string[], namespaces: string[]) => {
          // Return absolute URL for each language/namespace combination
          const lng = lngs[0];
          const ns = namespaces[0];
          if (typeof window !== 'undefined') {
            return `${window.location.origin}/locales/${lng}/${ns}.json`;
          }
          return `/locales/${lng}/${ns}.json`;
        },
      },
      interpolation: { escapeValue: false },
      react: { useSuspense: false },
    });
}

export default i18n;
